angular.module('tgaAdmin')
  .controller('PlayersController', ['$scope', '$state', 'playersService',
    function ($scope, $state, playersService) {
      $scope.data = {
        alerts: [],
      };

      $scope.viewmodel = {
        players: [],
      };

      $scope.initialize = function () {
        $scope.loading = true;

        playersService.getPlayers().then((players) => {
          $scope.viewmodel.players = players;
          $scope.loading = false;
        });
      };

      $scope.actions = {
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
